// WS-4 · Escasez real por lote (Devenir Café) — actualiza el número al cambiar de tamaño.
// El inventario es server-side y honesto; este JS solo recalcula al cambiar la variante.
// Vanilla, sin librerías, delegación en document (sobrevive al morph del tema).

function currentSizeValue(keys) {
  const picker = document.querySelector('variant-picker');
  if (!picker) return null;
  // Botones (radios): el valor del radio marcado coincide con una clave del mapa.
  for (const r of picker.querySelectorAll('input[type="radio"]:checked')) {
    if (keys.includes(r.value)) return r.value;
  }
  // Dropdowns (selects): el valor seleccionado coincide con una clave del mapa.
  for (const s of picker.querySelectorAll('select')) {
    if (keys.includes(s.value)) return s.value;
  }
  return null;
}

function update(el) {
  let map = {};
  try {
    map = JSON.parse(el.dataset.sizeMap || '{}');
  } catch (_) {
    map = {};
  }
  const keys = Object.keys(map);
  const threshold = parseInt(el.dataset.threshold, 10) || 10;

  let size = null;
  let count;
  if (keys.length) {
    size = currentSizeValue(keys);
    count = size != null ? map[size] : null;
  }
  if (count == null) {
    // Sin opción de tamaño: usar el total del lote.
    count = el.dataset.total ? parseInt(el.dataset.total, 10) : null;
  }

  if (count == null || count <= 0 || count > threshold) {
    el.hidden = true;
    return;
  }

  const tpl = size != null ? el.dataset.tpl : el.dataset.tplNosize;
  const text = (tpl || '').replace('[n]', count).replace('[size]', size || '');
  const target = el.querySelector('[data-devenir-scarcity-text]') || el;
  target.textContent = text;
  el.hidden = false;
}

function updateAll() {
  document.querySelectorAll('[data-devenir-scarcity]').forEach(update);
}

document.addEventListener('change', (event) => {
  const t = event.target;
  if (t && t.closest && t.closest('variant-picker')) {
    updateAll();
  }
});

updateAll();
